import {createStore} from 'vuex';
import {getConfig, getRuleConfig, getLayerMapConfig, getFileConfig, getMainConfig, getThirdConfig} from './config';
import createOneWaySyncPlugin from './plugin';
import ManuResSyncPlugin from "./manuResPlugin";

// const upload_list = ["image", "pdf", "txt", "doc", "gbr", "rou", "drl", "ipc", "xls"]
// 窗口 A 是根路径 ('#/'), 窗口 B 是 '#/window-b'
const isMasterWindow = window.location.hash === '#/';

const store = createStore({
    state: {
        config: [],
        ruleConfig: {},
        layerMapConfig: {},
        fileConfig: {},
        mainConfig: {},
        thirdConfig: {}, // 第三方配置

        // 核心，所有list 实时刷新计算checklist，保持数据一致性
        pollingList: [], // 轮询机制，用于处理云端超长时间任务
        filePath: '', // 用于存储文件路径
        projectFileList: [], //commonObjList和 gerberObjList 之和
        commonObjList : [], //用于储存用户普通文件
        gerberObjList : [], //用于储存用户gerber文件
        drillMatchList: [],
        outerMatchList: [],
        silkMatchList: [],
        solderMatchList: [],
        otherMatchList: [],
        virtualCheckListMap:{}, //虚拟checklist，统计默认占位

        commonFileCheckKeywords: [],

        checkListItemTemplate: {
            'value' : "",
            'analyse': "",
            'file_path': "",
            'file_key': "",
            'help_value': "",
            'help_key': "",
            'manual': "",
            'value_origin': "",
        },

        projectId: "",
        selectFilePathMap: {},

        // // 最终结果，keyword: [{id, keyword, value, name, manu, analyse_value, file_key, help_file_value, help_file_key, type, config...},]
        // checkListMap: {},
        checkList: [],

        readOnlyMode: false,

        statusChangeSign: 0, // 同步文件状态
        commonFileChangeSign: 0, // 同步文件勾选
        gerberFileChangeSign: 0,
        checkListChangeSign: 0, // 同步文件参数交互
        stepSign: 0, // 同步界面点击轨迹
        translationChangeSign: 0,
        locationStateSign: 0,

        locationPath: "", //用于同步点击的文件
        coopPath: "", //用于同步点击的文件
        LocationTabName: "", //用于同步 定位/翻译 tab
        locationKeyword: "", //用于同步点击的参数

        fileAnnotationLogs: {}, // 存储文件标注日志字典: { 'D:/path/to/file.png': [LogObject, ...] }, 副窗口使用

        eq: [],

        layerInfo:{},

        startEq: false,

        activeTab: 'file-results',
        userName: '',
        userAvatar: '',
    },

    plugins: [createOneWaySyncPlugin({ isMaster: isMasterWindow }), ManuResSyncPlugin({ isMaster: isMasterWindow })],

    mutations: {
        setConfig(state, config) {
            state.config = config;
        },
        setRuleConfig(state, config) {
            state.ruleConfig = config;
        },
        setLayerMapConfig(state, config) {
            state.layerMapConfig = config;
        },
        setFileConfig(state, config) {
            state.fileConfig = config;
        },

        setMainConfig(state, config) {
            state.mainConfig = config;
        },

        setThirdConfig(state, config) {
            state.thirdConfig = config;
        },

        setReadOnly(state, isReadOnly) {
            state.readOnlyMode = isReadOnly;
        },

        setFilePath(state, path) {
            state.filePath = path;
        },
        setCommonObjList(state, newList) {
            state.commonObjList = newList;
        },
        setSelectFilePathMap(state, newMap) {
            state.selectFilePathMap = newMap;
        },
        setActiveTab(state, tabName) {
            state.activeTab = tabName;
        },
        setCheckListMap(state, checkListMap) {
            state.checkListMap = checkListMap;
        },
        setEq(state, eq) {
            state.eq = eq;
        },
        setStartEq(state, start) {
            state.startEq = start;
        },
        setCheckList(state, checkList) {
            state.checkList = checkList;
        },
        setUserInfo(state, { userName, userAvatar }) {
            state.userName = userName;
            state.userAvatar = userAvatar;
        },
        setGerberObjList(state, gerberObjList) {
            state.gerberObjList = gerberObjList;
        },
        setLayerInfo(state, info) {
            state.layerInfo = info;
        },
        setProjectId(state, id) {
            state.projectId = id;
        },

        setStepSign(state, sign) {
            state.stepSign = sign;
        },

        addCommonFileChangeSign(state) {
            state.commonFileChangeSign += 1;
        },
        addGerberFileChangeSign(state) {
            state.gerberFileChangeSign += 1;
        },

        addStatusChangeSign(state) {
            state.statusChangeSign += 1;
        },

        addTranslationChangeSign(state) {
            state.translationChangeSign += 1;
        },

        addLocationStateSign(state) {
            state.locationStateSign += 1;
        },


        addCheckListChangeSign(state) {
            state.checkListChangeSign += 1;
        },

        setDrillMatchList(state, marchList) {
            state.drillMatchList = marchList;
        },
        setOuterMatchList(state, marchList) {
            state.outerMatchList = marchList;
        },
        setSilkMatchList(state, marchList) {
            state.silkMatchList = marchList;
        },
        setSolderMatchList(state, marchList) {
            state.solderMatchList = marchList;
        },
        setOtherMatchList(state, marchList) {
            state.otherMatchList = marchList;
        },

        setProjectFileList(state, projectFileList) {
            state.projectFileList = projectFileList;
        },

        setLocationPath(state, locationPath) {
            state.locationPath = locationPath;
        },

        setCoopPath(state, coopPath) {
            state.coopPath = coopPath;
        },

        setLocationTab(state, tabName) {
            state.LocationTabName = tabName;
        },

        setLocationKeyword(state, locationKeyword) {
            state.locationKeyword = locationKeyword;
        },

        addProjectFileList(state, newList) {
            state.projectFileList.concat(newList)
        },

        addCommonObjList(state, newList) {
            newList.forEach(item => {
                state.commonObjList.push(item);
            })
        },

        addGerberObjList(state, newList) {
            newList.forEach(item => {
                state.gerberObjList.push(item);
            })
        },

        registerPollingTask(state, p) {
            state.pollingList.push(p);
            p.start()
        },

        clearPollingList(state) {
            state.pollingList.forEach(p => {
                p.stop()
            })
            state.pollingList = []
        },

        // 添加单条日志
        ADD_FILE_ANNOTATION_LOG(state, { filePath, log }) {
            if (!state.fileAnnotationLogs[filePath]) {
                state.fileAnnotationLogs[filePath] = [];
            }
            state.fileAnnotationLogs[filePath].push(log);
        },

        // 初始化/覆盖日志 (可选，用于清除等)
        SET_FILE_ANNOTATION_LOGS(state, { filePath, logs }) {
            state.fileAnnotationLogs[filePath] = logs;
        },

        UPDATE_PARTIAL_STATE(state, newState) {
            const allowReplaceAttr = [
                "filePath",
                "commonObjList",
                "statusChangeSign", "commonFileChangeSign","checkListChangeSign","translationChangeSign","locationStateSign",
                "locationPath", "LocationTabName", "locationKeyword"
            ]
            const partialState = {};
            for (const key of allowReplaceAttr) {
                partialState[key] = newState[key];
                // console.log(`属性: ${key}; 当前值：${state[key]}; 替换值：${newState[key]}`)
            }
            Object.assign(state, partialState);
            console.log("newState", newState, state);
        }
    },

    actions: {
        async fileCheckListLevelChange({commit, state}) {
            commit('addCheckListChangeSign');
            // console.log("fileCheckListLevelChange")
            const stateCopy = JSON.parse(JSON.stringify(state));
            // 通知主进程推送当前状态
            await window.electronAPI.send('push-state-to-windows', stateCopy);
        },

        async syncWindowState({commit, state}) {
            const stateCopy = JSON.parse(JSON.stringify(state));
            // 通知主进程推送当前状态
            await window.electronAPI.send('push-state-to-windows', stateCopy);
        },

        async initializeConfig({ commit }) {
            try {
                const config = await getConfig();
                console.log("initializeConfig", config);
                commit('setConfig', config);
            } catch (error) {
                console.error("Failed to initialize config, using default.", error);
                commit('setConfig', []); // 如果失败，保持默认的空数组
            }
            try {
                const ruleConfig = await getRuleConfig();
                console.log("initializeRuleConfig", ruleConfig);
                commit('setRuleConfig', ruleConfig);
            } catch (error) {
                console.error("Failed to initialize ruleConfig, using default.", error);
                commit('setRuleConfig', {}); // 如果失败，保持默认的空数组
            }

            try {
                const layerMapConfig = await getLayerMapConfig();
                console.log("initializeLayerMapConfig", layerMapConfig);
                commit('setLayerMapConfig', layerMapConfig);
            } catch (error) {
                console.error("Failed to initialize layerMapConfig, using default.", error);
                commit('setLayerMapConfig', {}); // 如果失败，保持默认的空数组
            }

            try {
                const fileConfig = await getFileConfig();
                console.log("initialFileConfig", fileConfig);
                commit('setFileConfig', fileConfig);
            } catch (error) {
                console.error("Failed to initialize fileConfig, using default.", error);
                commit('setFileConfig', {}); // 如果失败，保持默认的空数组
            }

            try {
                const mainConfig = await getMainConfig();
                console.log("initialMainConfig", mainConfig);
                commit('setMainConfig', mainConfig);
            } catch (error) {
                console.error("Failed to initialize fileConfig, using default.", error);
                commit('setMainConfig', {}); // 如果失败，保持默认的空数组
            }

            try {
                const thirdConfig = await getThirdConfig();
                console.log("initialThirdConfig", thirdConfig);
                if (thirdConfig) {
                    commit('setThirdConfig', thirdConfig);
                } else {
                    console.error("Failed to initialThirdConfig.");
                }
            } catch (error) {
                console.error("Failed to initialThirdConfig.", error);
            }
        },


        getCommonKeywords({state}) {
            if (state.commonFileCheckKeywords.length) {
                return state.commonFileCheckKeywords;
            }
            const keywords = []

            const checkListItemTemplate = state.checkListItemTemplate
            console.log(" state.config",  state.config)
            console.log(" state.ruleConfig",  state.ruleConfig)
            const commonCheckList = state.config['commonItems']

            commonCheckList.map(item => {
                const newItem = {...checkListItemTemplate}
                Object.assign(newItem, item)

                keywords.push({
                    "keyword": item["keyword"],
                    "synonyms": item["range_zh"].concat(item['range_eng']),
                })
            })
            state.commonFileCheckKeywords = keywords
            return keywords
        },

        async fetchUserInfo({ commit }) {
            let callbackUrl = window.electronAPI.callbackUrl

            if (!callbackUrl) {
                callbackUrl = "http://localhost:8080"
            }


            const temp_url = `https://talans.cn/account/app/wx_work?mode=common&appid=ww8c593a55a08d85dd&cb=${encodeURIComponent(callbackUrl)}&agentid=1000007`
            console.log("auth back url", temp_url)
            try {
                // 发起请求获取用户信息
                const response = await window.electronAPI.request(
                    'get',
                    'https://talans.cn/account/api/user/info',
                    {},
                    { withCredentials: true }
                );

                if (!response.success) {
                    // 如果请求失败且状态码为 401，则跳转到登录页面
                    if (response.status === 401) {
                        console.warn('User not authenticated. Redirecting to login...');
                        location.href = temp_url
                        return;
                    } else {
                        throw new Error(`Error fetching user info: ${response.message}`);
                    }
                }

                const resData = response.data || {};
                const userInfo = resData.data || {};
                commit('setUserInfo', {
                    userName: userInfo.name || 'UnLogin User',
                    userAvatar: userInfo.avatar || 'user-avatar.png',
                });
            } catch (error) {
                console.error('Unexpected error fetching user info:', error);
                if (error.response && error.response.status === 401) {
                    console.warn('User not authenticated. Redirecting to login...');
                    window.location.href = temp_url
                }
            }
        },
    },

    getters: {
        getFilePath: (state) => state.filePath,
        getFileDescribeObjList: (state) => state.fileDescribeObjList,
        getSelectFilePathMap: (state) => state.selectFilePathMap,
        getUserName: (state) => state.name,
        getUserAvatar: (state) => state.avatar,
    },
});


await store.dispatch('initializeConfig');
export default store;
